package com.wintermar.inspection.feature.presentation.splash

sealed class SplashEvent {
    data object NavigateToLogin : SplashEvent()
    data object NavigateToLanding : SplashEvent()
}
